function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * iFrame payment form
 * 
 */
import React from 'react';
import ErrorMessage from '../../../components/error-message/ErrorMessage';
import Loading from '../../../components/loading/Loading';
import { COSTS } from '../../../data/Data';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
class IPSIframe extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "timeoutId", void 0);
    /**
     * show iFrame
     */
    _defineProperty(this, "showIframe", () => {
      this.setState({
        show: true
      });
    });
    /**
     * Capture iFrame onLoad event
     */
    _defineProperty(this, "onIpsiIframeLoad", () => {
      const {
        loadCount
      } = this.state;
      if (loadCount >= 1) {
        // reload window because IPSI implementation is a steaming pile of dingos kidneys
        window.location.reload();
      }
      this.setState({
        loadCount: loadCount + 1
      });
    });
    /**
     * Payment error on timeout of request to IPSI gateway by iFrame
     */
    _defineProperty(this, "paymentTimeout", () => {
      const {
        bugsnagClient,
        application
      } = this.props;
      console.warn('IPSI TIMEOUT payment gateway error props', this.props);
      console.warn('IPSI TIMEOUT payment gateway error state', this.state);
      const err = new Error(`IPSI payment gateway TIMEOUT error for applicationId: ' + ${application.id}`);
      bugsnagClient.notify(err);
      this.setState({
        gatewayError: true
      });
    });
    /**
     * listenPostMessage
     * listen to post messages passed from the embedded iFrame
     */
    _defineProperty(this, "listenPostMessage", e => {
      const {
        bugsnagClient,
        application
      } = this.props;
      const {
        data,
        origin
      } = e;
      if (/enterprisesecure\.com\.au/.test(origin) && typeof data === 'string') {
        const messageData = JSON.parse(data);

        // Errors
        if (messageData['data'] !== undefined && messageData.data['errors'] !== undefined) {
          const err = new Error('IPSI payment gateway error for applicationId: ' + application.id + '. Response data: ' + data);
          bugsnagClient.notify(err);
          this.setState({
            gatewayError: true
          });
          return null;
        }

        // Parse other messages
        switch (true) {
          case messageData.info && messageData.info === 'iframe content for payment page is loading.':
            this.setState({
              status: 'loading'
            });
            break;
          case messageData.info && messageData.info === 'The payment form has rendered.':
            this.setState({
              status: 'loaded',
              show: true
            });
            break;
          case messageData.info && messageData.info === 'The confirmation form has rendered.':
            this.setState({
              status: 'confirmation'
            });
            break;
          case messageData.info && messageData.info === 'The confirmation form has been submitted.':
            this.setState({
              status: 'submitted'
            });
            this.timeoutId = setTimeout(this.paymentTimeout, 10000);
            break;

          /*
            Successful transaction data structure example:
            {
              "transactionDate": "2023-10-20T05:59:03Z",
              "browser": "chrome",
              "os": "macosx",
              "currency": "$",
              "body": "Approved",
              "os_version": "10.15",
              "ecm": "31",
              "success": "true",
              "requestorIp": "172.16.11.176",
              "info": "Payment outcome for the transaction.",
              "maskedPAN": "424242XXXXXX4242",
              "cardExpiryDate": "01/25",
              "responseCode": "00",
              "name": "test",
              "txnReference": "123506f0e19c909",
              "merchantReference": "10640-1697781500",
              "cardSchema": "VISA",
              "finalAmount": "60.00",
              "cardCategory": "CREDIT",
              "browser_engine": "webkit",
              "settlementDate": "2023-10-20T07:00:00Z",
              "surcharge": "null",
              "header": "Approved",
              "iframeName": "2d8f79819c84da18c51eaa00049014a84619168ee10aa8305415cd0ea0423aeb"
            }
          */
          case messageData.info && messageData.info === 'Payment outcome for the transaction.':
            {
              clearTimeout(this.timeoutId);
              const {
                body,
                finalAmount,
                merchantReference,
                responseCode,
                success,
                txnReference
              } = messageData;
              this.setState({
                results: {
                  amount: finalAmount,
                  message: body,
                  responseCode: responseCode,
                  receipt: txnReference,
                  reference: merchantReference,
                  successful: success === 'true' ? true : false,
                  status: 'paymentOutcome'
                },
                redirect: true
              });
              break;
            }
          default:
          // no op
        }
      }
    });
    this.state = {
      gatewayError: false,
      loadCount: 0,
      redirect: false,
      results: null,
      show: false,
      status: ''
    };
  }
  componentDidMount() {
    window.addEventListener('message', this.listenPostMessage);
    this.timeoutId = setTimeout(this.showIframe, 2000);
  }
  componentWillUnmount() {
    clearTimeout(this.timeoutId);
    window.removeEventListener('message', this.listenPostMessage);
  }
  render() {
    const {
      application,
      gateway,
      postage,
      transaction
    } = this.props;
    const {
      gatewayError,
      redirect,
      results,
      show
    } = this.state;
    const {
      gateway_url,
      token
    } = transaction;
    const {
      params,
      redirectUrl
    } = gateway;
    if (!gateway_url || !params || !token) {
      return null;
    }
    const src = `${gateway_url}?${params}&verifyMessage=${token}`;
    if (!show) {
      return /*#__PURE__*/_jsx(Loading, {});
    }
    if (redirect && results) {
      const {
        amount,
        message,
        reference,
        responseCode,
        successful
      } = results;
      const search = new URLSearchParams();
      search.set('id', application.id);
      search.set('submission_token', application.submission_token);
      search.set('amount', amount && typeof amount === 'string' ? amount : `${(postage.cost + COSTS.permit).toFixed(0)}`);
      search.set('reference', reference && typeof reference === 'string' ? reference : 'Error');
      search.set('responseCode', responseCode && typeof responseCode === 'string' ? responseCode : '');
      search.set('message', message && typeof message === 'string' ? message : 'Error');
      search.set('receipt', reference && typeof reference === 'string' ? reference : '');
      search.set('successful', successful ? 'true' : 'false');
      search.set('postage', postage.description ? postage.description : 'Express Post within Australia');
      window.location = `${redirectUrl}?${search.toString()}`;
      return null;
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ErrorMessage, {
        error: gatewayError,
        message: 'Payment gateway error'
      }), /*#__PURE__*/_jsx("iframe", {
        src: src,
        title: "Payment iFrame",
        onLoad: this.onIpsiIframeLoad
      })]
    });
  }
}
_defineProperty(IPSIframe, "defaultProps", {
  application: {
    club: {
      abbreviation: 'RACV'
    },
    id: '1500',
    referrer: '',
    submission_token: 'f23re5et'
  },
  bugsnagClient: {
    notify: () => null
  },
  gateway: {
    name: '',
    method: '',
    redirectUrl: ''
  },
  postage: {
    description: 'Express Post within Australia',
    cost: 11.75,
    value: 'express_post'
  },
  transaction: {
    community_code: null,
    gateway_url: null,
    paymentAmount: null,
    paymentReference: null,
    receiptNumber: null,
    responseCode: null,
    responseDescription: null,
    summaryCode: null,
    success: false,
    token: null,
    tokenSuccess: null
  },
  jest: false
});
export default IPSIframe;